import React from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useYupValidationResolver } from '@cp/ds/src/components/form/hooks/useYupValidationResolver';
import { coreClientAuthApi } from 'src/entities/client/auth';
import { useWithTrack } from 'src/shared/tracking';
import { useApiServerErrorHandler } from 'src/shared/apiServer';
import { AuthByPhoneFormSubmit } from '../../lib';
import { LoginStrategy } from '../../model';
import { View } from './view';
import { LoginFormModel, LoginFormProps, ViewProps } from './types';
import { createLoginSchema } from './validation';

export const LoginForm: React.FC<LoginFormProps> = ({ loginStrategy, onSuccess, ...restProps }) => {
  const validationSchema = React.useMemo(() => createLoginSchema({ loginStrategy }), [loginStrategy]);
  const resolver = useYupValidationResolver<LoginFormModel>(validationSchema);
  const [login] = coreClientAuthApi.endpoints.login.useMutation();
  const handleApiServerError = useApiServerErrorHandler();
  const withTrack = useWithTrack();

  const form = useForm<LoginFormModel>({
    defaultValues: {},
    resolver,
  });

  const handleSubmit: SubmitHandler<LoginFormModel> = async (values) => {
    const response = await login(values);

    if ('error' in response) {
      handleApiServerError(response.error, { form });
    } else {
      return onSuccess({
        ...response.data,
        login: String(loginStrategy === LoginStrategy.Phone ? values.phoneNumber : values.email),
        loginStrategy,
      });
    }
  };

  const viewProps: ViewProps = {
    loginStrategy,
    form,
    onSubmit: withTrack(() => AuthByPhoneFormSubmit(), handleSubmit),
    ...restProps,
  };

  return <View {...viewProps} />;
};
